import { MarketCountryCode } from '@backmarket/http-api'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

interface BuybackData {
  recyclingLink: boolean
  faq: Record<
    'backup' | 'counterOffer' | 'dropOff' | 'google' | 'icloud' | 'laPoste',
    string
  > | null
}

const buybackConfig: Record<string, BuybackData> = {
  [MarketCountryCode.FR]: {
    recyclingLink: true,
    faq: {
      backup:
        'https://help.backmarket.com/hc/fr-fr/articles/360010648979-Comment-sauvegarder-et-supp%5B%E2%80%A6%5D-il-aux-donn%C3%A9es-de-mon-appareil-apr%C3%A8s-sa-revente-',
      counterOffer:
        'https://help.backmarket.com/hc/fr-fr/articles/360021663319',
      dropOff: 'https://localiser.laposte.fr/?jesuis=particulier&contact=boite',
      google:
        'https://help.backmarket.com/hc/fr-fr/articles/360012127479-Comment-d%C3%A9connecter-mon-compte-iCloud-Google-',
      icloud:
        'https://help.backmarket.com/hc/fr-fr/articles/360012127479-Comment-d%C3%A9connecter-mon-compte-iCloud-Google-',
      laPoste: 'https://localiser.laposte.fr/?jesuis=particulier&contact=vente',
    },
  },
  [MarketCountryCode.US]: {
    recyclingLink: true,
    faq: null,
  },
  [MarketCountryCode.DE]: {
    recyclingLink: false,
    faq: null,
  },
  [MarketCountryCode.ES]: {
    recyclingLink: false,
    faq: null,
  },
  [MarketCountryCode.GB]: {
    recyclingLink: false,
    faq: null,
  },
}

export function useBuybackConfig(): BuybackData | undefined {
  const { market } = useMarketplace()

  return buybackConfig[market.countryCode]
}
